import React from 'react';
import { motion } from 'framer-motion';
import { GlassCard } from './ui/GlassCard';
import { GraduationCap, Gem, Gamepad2, Globe2, Car, HeartPulse } from 'lucide-react';
const ventures = [{
  title: 'Eğitim Teknolojileri',
  icon: GraduationCap,
  desc: 'Sınav süreçlerini dijitalleştiriyor, başarıyı erişilebilir kılıyoruz.',
  color: 'text-neon-cyan'
}, {
  title: 'Dijital Mücevherat',
  icon: Gem,
  desc: 'Geleneksel kuyumculuğu e-ticaretin hızı ve güveniyle buluşturuyoruz.',
  color: 'text-electric-violet'
}, {
  title: 'Oyun Stüdyosu',
  icon: Gamepad2,
  desc: 'Mobil ve PC platformlarında, küresel standartlarda eğlenceli deneyimler üretiyoruz.',
  color: 'text-neon-cyan'
}, {
  title: 'Global Yayıncılık',
  icon: Globe2,
  desc: 'Yerli oyun projelerini dünya pazarlarına taşıyor ve büyütüyoruz.',
  color: 'text-electric-violet'
}, {
  title: 'Otomotiv Yazılım',
  icon: Car,
  desc: 'Araçların yazılımsal sorunlarını çözüyor, performansı optimize ediyoruz.',
  color: 'text-neon-cyan'
}, {
  title: 'Sağlık Turizmi',
  icon: HeartPulse,
  desc: "Global hastaları, Türkiye'nin gelişmiş sağlık altyapısıyla buluşturuyoruz.",
  color: 'text-electric-violet'
}];
export function VenturesGrid() {
  return <section className="py-24 px-4 relative" id="ventures" data-id="element-141">
      <div className="max-w-7xl mx-auto" data-id="element-142">
        <div className="text-center mb-16 space-y-4" data-id="element-143">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-bold text-white" data-id="element-144">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-electric-violet" data-id="element-145">
              Girişim Odaklarımız
            </span>
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-146">
          {ventures.map((venture, index) => <GlassCard key={index} hoverEffect delay={index * 0.1} className="group" data-id="element-147">
              <div className="h-full flex flex-col" data-id="element-148">
                <div className={`mb-6 p-3 rounded-xl bg-white/5 w-fit group-hover:bg-white/10 transition-colors ${venture.color}`} data-id="element-149">
                  <venture.icon className="w-8 h-8" data-id="element-150" />
                </div>

                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-neon-cyan transition-colors" data-id="element-151">
                  {venture.title}
                </h3>

                <p className="text-gray-400 leading-relaxed" data-id="element-152">{venture.desc}</p>

                
              </div>
            </GlassCard>)}
        </div>
      </div>
    </section>;
}